import { useStore } from 'vuex';
import {
  getLatestTrackPositionByTimestamp,
  getSecondsFromHMSString,
} from '@/helpers/functions';

export default function useRecentlyPlayed() {
  const store = useStore();

  function getNotCompletedPodcasts(podcast) {
    const storageProgressData =
      store.state.player.recentlyPlayedProgress[podcast.id];
    const time =
      getLatestTrackPositionByTimestamp(podcast, storageProgressData) ??
      '00:00:00';
    const secondsLeft = podcast.duration - getSecondsFromHMSString(time);

    return Math.round(secondsLeft / 60) > 0;
  }

  return {
    getNotCompletedPodcasts,
  };
}
